import { render, staticRenderFns } from "./VsLazyLoad.vue?vue&type=template&id=7d71ff7e&lang=pug&"
import script from "./VsLazyLoad.vue?vue&type=script&lang=js&"
export * from "./VsLazyLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d71ff7e')) {
      api.createRecord('7d71ff7e', component.options)
    } else {
      api.reload('7d71ff7e', component.options)
    }
    module.hot.accept("./VsLazyLoad.vue?vue&type=template&id=7d71ff7e&lang=pug&", function () {
      api.rerender('7d71ff7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/viralstyle-ui/src/VsLazyLoad.vue"
export default component.exports